<template>
  <div class="main-box">
    <el-scrollbar class="main-wrapper">
      <div style="border-bottom: 2px solid #F1F5FF;padding-bottom: 14px;text-align: right;margin: 0 20px"><el-button @click="goBack" type="primary">返回</el-button></div>
      <StudentAnswerDetail v-if="Object.keys(answerData).length > 0" :answerData="answerData" />
      <div v-else style="text-align: center;margin-top: 40px">暂无数据</div>
    </el-scrollbar>
  </div>
</template>

<script>
import {trainAnswerDetailTeacher} from '@/utils/apis'
import StudentAnswerDetail from '@/components/StudentAnswerDetail.vue'
export default {
  name: "ExamStudentAnswerDetail",
  components:{
    StudentAnswerDetail
  },
  data(){
    return {
      userId:this.$route.query.userId || null,
      trainLogId:this.$route.query.trainLogId || null,
      answerData:{}
    }
  },
  mounted() {
    this.getTrainAnswerDetailTeacher()
  },
  methods:{
    getTrainAnswerDetailTeacher(){
      let params = {
        student_theory_train_log_id:this.trainLogId,
        user_id:this.userId
      }
      trainAnswerDetailTeacher(params).then((res)=>{
        for(let i in res.data.bottom_data){
          res.data.bottom_data[i].list.forEach(item=>{
            this.$set(item, 'isAnalysisShow', false)
          })
        }
        this.answerData = res.data;
      }).catch((err)=>{
        console.log('err',err)
      })
    },
    goBack(){
      this.$router.go(-1)
    }
  }
}
</script>

<style scoped lang="scss">
.main-box {
  height: 100%;
}

.main-wrapper {
  height: 100%;

  ::v-deep > .el-scrollbar__wrap {
    overflow-x: hidden;
  }
}
</style>